// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__YMK8T","title":"InfoRow_title__17RQP"};